import { zip } from 'rxjs/operators';
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { LanguageService, ApplicationService, MachineFamillyService } from '../../shared/services/index';
import { BaseModalPageComponent } from '../../base-modal.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PeopleService } from '../../shared/services';
import { Person } from '../../shared/models';
import { maxPhoneLengthValidator } from '../../utils/maxPhoneLength.directive';
import * as _ from 'lodash';
import { LocalEntityPipe, ProfilPipe } from '../../pipes';

@Component({
    templateUrl: './edit-user.component.html',
    standalone: false
})
export class EditUserPageComponent extends BaseModalPageComponent implements OnInit {
  public person: Person;
  editForm: UntypedFormGroup;
  public processing = false;
  public languages: any[];
  public applicationTypes: any[];
  public productLines: any[];

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private language: LanguageService,
    private peopleService: PeopleService,
    private applicationService: ApplicationService,
    private localEntityPipe: LocalEntityPipe,
    private profilPipe: ProfilPipe,
    private machineFamillyService: MachineFamillyService,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.language.getLanguageList().subscribe((data) => (this.languages = data));
    this.peopleService
      .getCurrent()
      .pipe(zip(this.machineFamillyService.getProductLines(), this.applicationService.getApplicationTypes()))
      .subscribe(([data, productLines, applicationTypes]) => {
        this.person = data;
        this.applicationTypes = applicationTypes.filter(
          (type) => this.person.applicationTypes && this.person.applicationTypes.includes(type.Value)
        );

        productLines.push(this.machineFamillyService.getAllProductLineItem());
        this.productLines = _.map(productLines, (p) => ({
          id: 'productline-' + p.id,
          name: p.name,
          label: p.name
        }));
        this.productLines = _.orderBy(this.productLines, ['name']);
        _.each(this.person.productLine, (el) => {
          const i = _.findIndex(this.productLines, ['id', el]);
          if (i !== -1) {
            this.productLines[i].selected = true;
          }
        });
        this.initForm();
      });
  }

  save(model: any): void {
    this.processing = true;
    this.peopleService
      .updateCurrentPerson(this.person.id, {
        name: model.name,
        description: model.desc,
        phone: model.phone,
        email: model.email,
        language: model.language
      })
      .subscribe((person: any) => {
        this.processing = false;
        this.person = person;
        this.goToBack();
      });
  }

  public cancel() {
    this.goToBack();
  }

  public goToEditPassword() {
    this.router.navigate([this.settingsRoute, 'editUser', 'editPassword']);
  }

  initForm() {
    const regex = new RegExp(/<br\s*[\/]?>/gi);

    this.editForm = new UntypedFormGroup({
      name: new UntypedFormControl(this.person != null ? this.person.name : '', Validators.required),
      desc: new UntypedFormControl(
        this.person != null && this.person.desc ? this.person.desc.replace(regex, '\n') : ''
      ),
      email: new UntypedFormControl(this.person != null ? this.person.email : ''),
      phone: new UntypedFormControl(this.person != null ? this.person.phone : '', [
        Validators.pattern(/^([+]?\d{1,2}[-| \s]?)?(\d{1,4}[-| ]?){1,4}?(\d{1,4}[-| ]?)\d{1,4}$/),
        Validators.minLength(10),
        maxPhoneLengthValidator(21)
      ]),
      language: new UntypedFormControl(this.person != null ? this.person.language : '')
    });
  }

  public getSelectedValues(): string {
    const defaultValue = 'No one permission is selected';
    const values = _.map(this.person.permissions, (item: any) => this.profilPipe.transform(item));
    return values.length > 0 ? values.join('<br/>') : defaultValue;
  }

  public getSelectedLocalEntitiesValues(): string {
    const defaultValue = 'No one local entity is selected';
    const values = _.map(this.person.localEntities, (item: any) => this.localEntityPipe.transform(item));
    return values.length > 0 ? values.join('<br/>') : defaultValue;
  }

  public getSelectedProductLineValues(): string {
    const defaultValue = 'No one product line is selected';
    let selectedValues = _.filter(this.productLines, (item: any) => item.selected);
    selectedValues = selectedValues.map((s) => s.name);
    return selectedValues.length > 0 ? selectedValues.join('<br/>') : defaultValue;
  }

  goToBack(): void {
    this.router.navigate([this.settingsRoute]);
  }
}
